import AvataUpload from "components/AvataUpload";
import {
  Button,
  Col,
  DatePicker,
  Form,
  FormInstance,
  Input,
  Row,
  Select,
  Spin,
  Typography,
} from "antd";
import React, { FC, useEffect, useState } from "react";
import styled from "@emotion/styled";

interface SettingPointFormAddProps {
  form: FormInstance;
  onFinish: (values: any) => void;
  isPending: boolean;
}

const SettingPointFormAdd: FC<SettingPointFormAddProps> = ({
  form,
  onFinish,
  isPending,
}) => {
  return (
    <>
      <Form
        form={form}
        onFinish={onFinish}
        labelCol={{ span: 8 }}
        wrapperCol={{ span: 16 }}
      >
        <Form.Item
          required
          label="จำนวนเงินที่เติม"
          labelAlign="left"
          name="money_amt"
          rules={[
            {
              required: false,
              message: "กรุณากรอกจำนวนเงินที่เติม",
            },
          ]}
        >
          <Input type="number" placeholder="จำนวนเงินที่เติม" />
        </Form.Item>

        <Form.Item
          required
          label="จำนวน Point ที่ได้รับ"
          labelAlign="left"
          name="point_amt"
          rules={[
            {
              required: false,
              message: "กรุณากรอกจำนวน Point ที่ได้รับ",
            },
          ]}
        >
          <Input type="number" placeholder="จำนวน Point ที่ได้รับ" />
        </Form.Item>

        <Form.Item>
          <WrapperButton>
            <Button
              style={{ width: 250 }}
              type="primary"
              size="large"
              htmlType="submit"
              disabled={isPending}
            >
              บันทึก
            </Button>
          </WrapperButton>
        </Form.Item>
      </Form>
    </>
  );
};

export default SettingPointFormAdd;

const WrapperButton = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 20px;
  margin-top: 20px;
  width: 100%;
`;
